import { render, staticRenderFns } from "./InvoiceBankDetails.vue?vue&type=template&id=2a947a24&"
import script from "./InvoiceBankDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports